export default "/Gwanghwamun.glb";